import type { SiteAppearance } from '@icetus/contracts';

/**
 * 归一当前站点的 (主题, 变体) —— 只认**接口给的主题清单**，不认 theme-kit 自带的那四套。
 *
 * ## 为什么不能直接用 `normalizeAppearance()`
 *
 * 控制台是静态包，`@icetus/theme-kit` 里内置的只有 aurora / meridian / kiln / nocturne。
 * 后台发布进来的主题（钢市、流明、WL 塑管……）在浏览器这份清单里**不存在**，
 * 于是 `normalizeAppearance('steelmart', 'wide')` 会理直气壮地回退成
 * `aurora / classic`：外观卡上"当前使用"打在极光身上，而站点真正在跑的
 * 是钢市 —— 客户看到的就是"我的模板不对"。
 *
 * 更糟的是这个值会跟着保存表单提交。客户只是改了个电话、点了保存，
 * `appearance` 一并写库，整站主题就被静默换掉了。**显示错还能改回来，
 * 写错库要重挑一遍主题**。
 *
 * 所以：主题名一律以服务端给的为准，只有"变体在这套主题里不存在"才修 ——
 * 那是换主题时唯一真实会遇到的不一致（旧变体名沿用了上一套的）。
 * 清单里没有这套（还没加载完、已下架、没订阅）就**原样保留**，
 * 绝不替客户改成另一个主题。
 */
export function normalizeThemeChoice(
  appearance: SiteAppearance,
  catalog: readonly {
    name: string;
    variants: readonly { key: string }[];
    defaultVariant: string;
  }[],
): SiteAppearance {
  const summary = catalog.find((theme) => theme.name === appearance.theme);
  // 认不出这套：不认识就别动它。回退到"默认主题"是渲染层的兜底，
  // 不该由表单替客户做决定
  if (!summary) return appearance;
  if (summary.variants.some((variant) => variant.key === appearance.variant)) return appearance;
  return { ...appearance, variant: summary.defaultVariant };
}
